import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="text-sm">
      <ol className="flex flex-wrap items-center gap-2 text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700 cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <span className="flex h-4 w-4 items-center justify-center text-foreground-300"><i className="ri-arrow-right-s-line" /></span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}